import { createFileRoute, redirect } from '@tanstack/react-router'
import { FieldSettings } from '@/features/hr-employees/field-settings'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for employee field configuration — design 1p.
 *
 * Guarded on `employee.view` — the catalogue has no `hr_field_setting.*`
 * object, and deciding which fields the company records IS editing the shape
 * of the employee record, so it rides the employee authority rather than a key
 * of its own.
 */
export const Route = createFileRoute('/_authenticated/hr/field-settings')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'employee.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: FieldSettings,
})
